import { useEffect, useState } from 'react';

const useUserInteraction = () => {
  const [isInteracted, setIsInteracted] = useState(false);

  useEffect(() => {
    const handleActivity = () => {
      if (!isInteracted) {
        /*
          in order to improve INP we have to move this function into
          separate micro task by using setTimeout in order to reduce TBT
        */
        setTimeout(() => {
          setIsInteracted(true);
        }, 0);
      }

      // Remove the event listeners after the first activity
      window.removeEventListener('scroll', handleActivity);
      window.removeEventListener('mousemove', handleActivity);
      window.removeEventListener('click', handleActivity);
    };

    window.addEventListener('scroll', handleActivity);
    window.addEventListener('mousemove', handleActivity);
    window.addEventListener('click', handleActivity);
    return () => {
      window.removeEventListener('scroll', handleActivity);
      window.removeEventListener('mousemove', handleActivity);
      window.removeEventListener('click', handleActivity);
    };
  }, []);

  return { isInteracted };
};

export default useUserInteraction;
